import { ITEM_KINDS, STATES } from '../../../constants';
import { actions, selectors } from '../../../state';

export const STATE_NAME = STATES.STEP_MOVING_CENTER;

// Map of move id -> flag indicating whether we checked MC data for that move.
const checkedMovingCenterData = {};

export function MovingCenterConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATE_NAME, {
    abstract: true,
    ignore: true,
    url: '/book-move',
    title: 'Book Your Move',
    data: {
      moveItem: {
        type: ITEM_KINDS.MOVING_CENTER,
        singleton: true,
      },
    },
    resolve: {
      // Want to fetch latest data prior to evaluating `hasMovingCenterData` role.
      // Achieve this by creating a resolve on `moveId`, a `hasMovingCenterData` dependency.
      moveId: (MovingCenterActions, updStore) => {
        'ngInject';
        const { dispatch, getState } = updStore;
        const state = getState();
        const moveId = selectors.current.move(state).id(state);

        if (checkedMovingCenterData[moveId]) {
          return moveId;
        }

        return dispatch(MovingCenterActions.fetch(moveId))
          .then(() => moveId, () => moveId)
          .finally(() => (checkedMovingCenterData[moveId] = true));
      },
    },
  });
}
